import { useEffect } from 'react';
import { TasksStore } from 'src/stores/TasksStore/TasksStore';

export const useAssignedTasksInterval = () => {
    useEffect(() => {
        const interval = window.setInterval(() => {
            TasksStore.hiddenLoadAssignedTasksList();
        }, 10000);

        return () => {
            clearInterval(interval);
        };
    }, []);
};
